import script from "./GestionBiens.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionBiens.vue?vue&type=script&setup=true&lang=js"

import "./GestionBiens.vue?vue&type=style&index=0&id=bdac337a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdac337a"]])

export default __exports__